import { Box, Button } from '@mui/material';
import { type MouseEvent } from 'react';
import type { EventDto } from '@/types/dtos/events/response/event.dto.ts';
import { type ProductDto, type ProductKey } from '@/types/dtos/orders/response/product.dto.ts';
import EventCatalogProductQuotas from '@/components/events/event-catalog/event-catalog-product-quotas.tsx';
import AddToCartButton from '../common/add-to-cart-button';
import { ORDER_STATUS } from '@/types/dtos/orders/response/order.dto';
import { getOriginEventId } from '@/helpers/event.helper';

interface EventProductsSectionProps {
  event: EventDto;
  products: ProductDto[];
  onCatalogAddClick: (
    clickEvent: MouseEvent<HTMLButtonElement> | undefined,
    event: EventDto,
    productKey?: ProductKey,
  ) => void;
  draftLineItemCount: number;
  isLargeScreen?: boolean;
}

export default function EventProductsSection({
  event,
  products,
  onCatalogAddClick,
  draftLineItemCount,
  isLargeScreen = false,
}: EventProductsSectionProps) {
  const latestOrder = event.orders?.find(
    (order) => order.status === ORDER_STATUS.DRAFT || order.status === ORDER_STATUS.PAYMENT_PENDING,
  );
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: isLargeScreen ? 'nowrap' : 'wrap',
        alignItems: 'center',
        py: 1,
        gap: 1,
        mt: isLargeScreen ? 0 : 1,
        maxWidth: '100%',
        overflow: isLargeScreen ? 'visible' : 'hidden',
        minWidth: isLargeScreen ? 'max-content' : 'auto',
      }}
    >
      {products?.map((product) => {
        if (!product) return null;

        return (
          <Button
            variant="contained"
            key={product.id}
            sx={{
              minWidth: 40,
              width: 40,
              height: 40,
              flexShrink: 0,
            }}
            onClick={(clickEvent) => onCatalogAddClick(clickEvent, event, product.key as ProductKey)}
          >
            <EventCatalogProductQuotas event={event} product={product} />
          </Button>
        );
      })}
      {isLargeScreen && (
        <AddToCartButton
          countItems={draftLineItemCount}
          isLoading={latestOrder?.status === ORDER_STATUS.PAYMENT_PENDING}
          onClick={(clickEvent) => onCatalogAddClick(clickEvent, event)}
          eventId={getOriginEventId(event)}
        />
      )}
    </Box>
  );
}
